import * as Candy from "@ravalmatic/candy-engine";

export class GameVars {

    public static gameData: GameDataCandy;
    public static gameAnalytics: any;
    public static scaleY: number;
    public static currentScene: Phaser.Scene;
    public static intitialised: boolean;
    public static paused: boolean;
    public static speedFactor: number;
    public static gameOver: boolean;
    public static forcedCombo: string;
    public static score: number;
    public static candyEngine: Candy.Engine;
    public static cols: number;
    public static rows: number;
    public static oneMoveBack: boolean;
    public static levelingUp: boolean;
    public static previousBoard: Candy.OrbData[][]; // estas 3 variables se usan para poder volver hacia atrás
    public static iPRNG: number;
    public static numOrbs: number;
    public static orbsMoving: boolean;
    public static playerData: any;
    public static development: boolean;
    public static actionsData: Candy.Action [];
    public static gameText: any;

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
}
